import React, { createContext, useState, useContext } from 'react';

const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    isOpen: false,
    type: 'alert', // 'alert' veya 'confirm' (onay)
    title: 'System Message',
    message: '',
    onConfirm: null,
  });

  const showAlert = (message, title = "Notice") => {
    setDialogState({
      isOpen: true, type: 'alert', title, message,
      onConfirm: () => setDialogState({ isOpen: false }),
    });
  };

  const showConfirm = (message, onConfirmCallback, title = "Action Required") => {
    setDialogState({
      isOpen: true, type: 'confirm', title, message,
      onConfirm: () => {
        setDialogState({ isOpen: false });
        if (onConfirmCallback) onConfirmCallback();
      },
    });
  };

  const closeDialog = () => setDialogState({ isOpen: false });

  return (
    <DialogContext.Provider value={{ showAlert, showConfirm }}>
      {children}
      
      {/* GLOBAL MODAL TASARIMI */}
      {dialogState.isOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(5,3,2,0.9)', zIndex: 9999999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(5px)' }}>
          <div style={{ width: '450px', maxWidth: '90%', backgroundColor: 'var(--sidebar-bg)', border: '1px solid #c5a059', borderRadius: '2px', padding: '35px', boxShadow: '0 15px 50px rgba(0,0,0,0.9)', backgroundImage: `url('https://www.transparenttextures.com/patterns/aged-paper.png')`, textAlign: 'center' }}>
            
            <h3 style={{ fontFamily: 'Cinzel, serif', color: '#c5a059', margin: '0 0 15px 0', fontSize: '1.4rem', letterSpacing: '2px', textTransform: 'uppercase', borderBottom: '1px dashed #e5d1a5', paddingBottom: '15px' }}>
              {dialogState.title}
            </h3>
            
            <p style={{ fontFamily: 'Courier Prime, monospace', color: '#fdfbf7', fontSize: '1.1rem', lineHeight: '1.6', margin: '25px 0 35px 0' }}>
              {dialogState.message}
            </p>
            
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              {dialogState.type === 'confirm' && (
                <button 
                  onClick={closeDialog} 
                  style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid #c5a059', color: '#e5d1a5', fontFamily: 'Cinzel, serif', fontWeight: 'bold', letterSpacing: '1.5px', cursor: 'pointer', transition: 'all 0.2s', borderRadius: '2px' }} 
                  onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(197, 160, 89, 0.1)'} 
                  onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  CANCEL
                </button>
              )}
              <button 
                onClick={dialogState.onConfirm} 
                style={{ flex: 1, padding: '10px', background: 'var(--accent-red)', border: '1px solid #5a0d0e', color: '#c5a059', fontFamily: 'Cinzel, serif', fontWeight: 'bold', letterSpacing: '1.5px', cursor: 'pointer', transition: 'all 0.2s', borderRadius: '2px', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' }} 
                onMouseOver={e => {e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = '#c5a059';}} 
                onMouseOut={e => {e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e';}}
              >
                {dialogState.type === 'confirm' ? 'PROCEED' : 'ACKNOWLEDGE'}
              </button>
            </div>

          </div>
        </div>
      )}
    </DialogContext.Provider>
  );
};